import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';

Vue.use(Router);

const routes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/login"),
    meta: {
      public: true,
      title: "Login",
      subHeading: "",
      requiresOrg: false,
      onlyWhenLoggedOut: true,
    },
  },
  {
    path: "/forgot",
    name: "Forgot Password",
    component: () => import("@/views/forgotpassword"),
    meta: {
      public: true,
      title: "Forgot Password",
      subHeading: "",
      requiresOrg: false,
      onlyWhenLoggedOut: true,
    },
  },
  {
    path: "/s/create",
    name: "Create",
    component: () => import("@/views/create"),
    meta: {
      public: true,
      title: "Create your space",
      subHeading: "",
      requiresOrg: false,
      onlyWhenLoggedOut: false,
    },
  },
  {
    path: "/",
    name: "Home",
    component: () => import("@/views/home.vue"),
    meta: {
      public: true,
      title: "Your organisations",
      subHeading: "Manage all your spaces",
      requiresOrg: false,
    },
  },
  {
    path: "/:org",
    name: "Reserve",
    component: () => import("@/views/reserve"),
    meta: {
      public: false,
      title: "Make Reservation",
      subHeading: "Reserve your space",
      requiresOrg: true,
    },
  },
  {
    path: "/:org/home",
    name: "Organisation",
    component: () => import("@/views/organisation"),
    meta: {
      public: false,
      title: "Dashboard",
      subHeading: "Your mission control",
      requiresOrg: true,
    },
  },
  {
    path: "/:org/resources",
    name: "Resources",
    component: () => import("@/views/resources"),
    meta: {
      public: false,
      title: "Resources",
      subHeading: "Manage everything your guests can reserve",
      requiresOrg: true,
    },
  },
  {
    path: "/:org/resources/new",
    name: "Create-Resource",
    component: () => import("@/views/createResource"),
    meta: {
      public: false,
      title: "Create Resource",
      subHeading: "Make it your own",
      requiresOrg: true,
      showBackArrow: true,
    },
  },
  {
    path: "/:org/resources/:resource",
    name: "Resource",
    component: () => import("@/views/resource"),
    meta: {
      public: false,
      title: "",
      subHeading: "Page description",
      requiresOrg: true,
      showBackArrow: true,
    },
  },
  {
    path: "/:org/groups/",
    name: "Groups",
    component: () => import("@/views/groups"),
    meta: {
      public: false,
      title: "Manage your floors/sections etc",
      subHeading: "P",
      requiresOrg: true,
      showBackArrow: false,
    },
  },
  {
    path: "/:org/groups/new",
    name: "Create-Group",
    component: () => import("@/views/createGroup"),
    meta: {
      public: false,
      title: "Create Group",
      subHeading: "Building, floor, section, area, etc..",
      requiresOrg: true,
      showBackArrow: true,
    },
  },
  {
    path: "/:org/groups/:group",
    name: "Group",
    component: () => import("@/views/group"),
    meta: {
      public: false,
      title: "",
      subHeading: "",
      requiresOrg: true,
      showBackArrow: true,
    },
  },
  {
    path: "/:org/teammates",
    name: "Organisation-Teammates",
    component: () => import("@/views/teammates"),
    meta: {
      public: false,
      title: "Teammates",
      subHeading: "Page description",
      requiresOrg: true,
    },
  },
  {
    path: "/:org/guests",
    name: "Organisation-Guests",
    component: () => import("@/views/guests"),
    meta: {
      public: false,
      title: "Guests",
      subHeading: "Page description",
      requiresOrg: true,
    },
  },
  {
    path: "/:org/guests/:guest",
    name: "Organisation-Guest",
    component: () => import("@/views/guest"),
    meta: {
      public: false,
      title: "Guest",
      subHeading: "",
      requiresOrg: true,
      showBackArrow: true,
    },
  },
  {
    path: "/:org/acceptguestinvite",
    name: "Organisation-Accept-Guest-Invite",
    component: () => import("@/views/guestinvite"),
    meta: {
      public: false,
      title: "Invitation",
      subHeading: "Page description",
      requiresOrg: false,
    },
  },
  {
    path: "/:org/settings",
    name: "Organisation-Settings",
    component: () => import("@/views/settings"),
    meta: {
      public: false,
      title: "Settings",
      subHeading: "Customise your guest experience",
      requiresOrg: true,
    },
  },
  {
    path: "/:org/myreservations",
    name: "My-Reservations",
    component: () => import("@/views/myreservations"),
    meta: {
      public: false,
      title: "Your reservations",
      subHeading: "Page description",
      requiresOrg: true,
    },
  },
  {
    path: "/:org/logs",
    name: "Audit-Logs",
    component: () => import("@/views/auditLogs"),
    meta: {
      public: false,
      title: "Audit Logs",
      subHeading: "audit-log-All-activity-in-your-account",
      requiresOrg: true,
    },
  },
  {
    path: "/:org/logs/:log",
    name: "Audit-Log",
    component: () => import("@/views/auditLog"),
    meta: {
      public: false,
      title: "View Log",
      subHeading: null,
      requiresOrg: true,
      showBackArrow: true,
    },
  },
  {
    path: "/:org/account",
    name: "Account",
    component: () => import("@/views/myaccount"),
    meta: {
      public: false,
      title: "Your Account",
      subHeading: "",
      requiresOrg: false,
    },
  },
  {
    path: "/s/account",
    name: "Account",
    component: () => import("@/views/myaccount"),
    meta: {
      public: false,
      title: "Your Account",
      subHeading: "Page description",
      requiresOrg: false,
    },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: () => import("@/views/notfound"),
    meta: {
      requiresOrg: false,
    },
  },
];

const router = new Router({
	routes: routes,
	mode: 'history',
	base: '/app',
  scrollBehavior (to, from, savedPosition) {    
    if (savedPosition) {
      return savedPosition
    } else if (to.hash) {
      return {
        selector: to.hash,
        behavior: "smooth",
      }
    } else if(to.path !== from.path) {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach(async (to, from, next) => {

  // console.log('to:', to);
  
  // update page title
  document.title = to.meta.title || 'Reservadesk.com'

  // guard against restricted routes
  const isPublic = to.matched.some(record => record.meta.public)
  const onlyWhenLoggedOut = to.matched.some(record => record.meta.onlyWhenLoggedOut)
  const requiresOrg = to.matched.some(record => record.meta.requiresOrg)
  const loggedIn = !!store.state.userAuth;


  if (
    (!store.state.activeOrg && requiresOrg) 
    || (requiresOrg && store.state.activeOrg && (to.params.org !== store.state.activeOrg.name))
    ) {
    // if we don't have an activeOrg and we need one
    // and if we need one, but there's a name mismatch
    // then we have to try set the active org by the route name
    // console.log("SETTING ORG BY NAME IN URL:", to.params.org)
    await store.dispatch("setOrgByName", to.params.org)

    if(!store.state.activeOrg) {
      console.log('no org found, handle...')
      return next({
        path:'/s/create',
        query: {
          missingOrg: to.params.org
        }  
      });
    }
  }


  if (!isPublic && !loggedIn) {
    // page isn't public and user isn't logged in, we need to rediret to login/signup page
    let purpose = null
    // check if it's a guest invite that the user is trying to access
    if(to.name === 'Organisation-Accept-Guest-Invite'){
      purpose = "acceptGuestInvite"
    }
    return next({
      path:'/login',
      query: {
        redirect: to.fullPath, // Store the full path to redirect the user to after login
        purpose: purpose
      }  
    });
  }


  // Do not allow user to visit login page or register page if they are logged in
  if (loggedIn && onlyWhenLoggedOut) {
    return next('/')
  }
  
  // if user is guest and selects an org from main screen, redirect them to the reserve page for that org
  if(to.name === "Organisation" && store.state.activeOrgAccess !== 'teammate'){
    return next(`/${store.state.activeOrg.name}`)
  }

  // handle if we're looking at a resource - set page title
  if(to.name === "Resource"){
    let id = to.params.resource
    let data = store.state.resources.docs.find(el => el.id === id)
    if(data){
      to.meta.title = data.name
    }
  }

  if(to.name === "Group"){
    let id = to.params.group
    let data = store.state.groups.docs.find((el) => el.id === id)
    if(data){
      to.meta.title = data.name
    }
  }

  next();
})


export default router